export const buildName = (firstName, lastName) => {
  return (`${firstName} ${lastName}`).trim()
}
